<script>
  import VueMedia from 'vue-media'

  VueMedia.name = 'VueMedia'

  function same(set1, set2) {
    if (!set1 || !set2) return false
    if (set1.size !== set2.size) return false

    for (const i of set1) {
      if (!set2.has(i)) return false
    }

    return true
  }

  const queries = {
    tablet: { screen: true, minWidth: 768 },
    laptop: { screen: true, minWidth: 1152 }
  }

  const common = new Set(['tablet'])

  export default {
    name: 'Media',

    common,

    components: {
      VueMedia
    },

    props: {
      value: {
        required: true
      }
    },

    data() {
      return {
        sizes: common
      }
    },

    mounted() {
      this.sizes = Object.keys(this.$refs).reduce((acc, key) => {
        if (this.$refs[key].matches) {
          acc.add(key)
        }
        return acc
      }, new Set())

      if (!same(this.sizes, this.value)) {
        this.emit()
      }
    },

    methods: {
      process(size, method) {
        const current = new Set([...this.sizes])

        this.sizes[method](size)

        if (!same(current, this.sizes)) {
          this.emit()
        }
      },

      emit() {
        this.$emit('input', new Set([...this.sizes]))
      }
    },

    render(createElement) {
      const children = Object.keys(queries).map((key) => {
        const query = queries[key]

        return createElement('vue-media', {
          ref: key,
          attrs: { query },
          on: {
            'media-enter': () => {
              this.process(key, 'add')
            },
            'media-leave': () => {
              this.process(key, 'delete')
            }
          }
        })
      })

      return createElement('div', {}, children)
    }
  }
</script>
